import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'beautify-scrollbar/dist/index.css'
import 'v2-table/dist/index.css'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VuetifyAsyncValidation from "vuetify-async-validation"

Vue.use(Vuetify)
Vue.use(VuetifyAsyncValidation)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  vuetify: new Vuetify(),
  store,
  router,
  icons: {
    iconfont: 'mdi',
  },
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/app/main.js